/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sl_Detail_Source_LegacyInputs */

const vi_sl_detail_source_legacy = /** @type {(inputs: Sl_Detail_Source_LegacyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nguồn cũ (kho chè mua đã bỏ)`)
};

/**

* @param {Sl_Detail_Source_LegacyInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const sl_detail_source_legacy = /** @type {((inputs?: Sl_Detail_Source_LegacyInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sl_Detail_Source_LegacyInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_sl_detail_source_legacy(inputs)
});